module.exports = __webpack_public_path__ + "static/media/yk_1.ae6b4356.jpg";